import { Page } from '@/core/architecture'

import { NewStoreItemsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * NewStoreItems Page
 * Implemented as a practical sample.
 */
export const NewStoreItems: Page = () => {
  const { state, actions } = useViewModel()

  return <NewStoreItemsTemplate state={state} {...actions} />
}
